module.exports = __webpack_public_path__ + "static/img/robot_bell.c33e2a55.svg";